/**
 * Extract component properties to be used in
 * the {@link uirouter.state.StateDeclaration} config
 * object. The intention is to simplify the eventual
 * migration to uirouter 1.x or Angular. Both of which
 * allow the implementer to declare a component for
 * every route
 *
 * @example
 *   angular.module('mymodule', ['ui.router'])
 *     .config(['$stateProvider', ($stateProvider) {
 *       $stateProvider.state({
 *         name: 'my.state',
 *         url: '/my/:state',
 *         ...uiRouterComponent(MyComponent),
 *       })
 *     })
 * @inspiredby https://ui-router.github.io/ng1/docs/latest/interfaces/state.statedeclaration.html
 * @inspiredby https://angular.io/api/router/Route
 * @param component
 */
export function uiRouterComponent(component: angular.IComponentOptions): Partial<angular.IComponentOptions> {
  const { controller, controllerAs, template } = component;

  return {
    ...(controllerAs ? { controllerAs } : {}),
    ...(controller ? { controller } : {}),
    ...(template ? { template } : {}),
  };
}
